export var MoveAnalyticPluginTypes = /*#__PURE__*/function (MoveAnalyticPluginTypes) {
  MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
  MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
  return MoveAnalyticPluginTypes;
}({});